<template>

  <modalo
    :creating="creating"
    title="Google (Gmail)"
    type="mini"
    @hideModal="hideModal()"
    :modaloWatch="() => settings">

    <form
      id="tag-form"
      v-on:submit.prevent="startSync(settings)">
      <div
        class="form-group">
        <label>{{ $t('Calendar name') }}</label>
        <div
          v-if="!isSynced"
          class="list-group">
          <label
            v-for="(item, index) in calendars"
            :key="index"
            style="cursor: pointer;"
            class="list-group-item">
            <input
              type="radio"
              :value="item.id"
              :selected="settings.calendar_id === item.id"
              v-model="settings.calendar_id">
            {{ item.name }}
          </label>
        </div>
        <div
          v-if="isSynced"
          class="alert alert-secondary">
          {{ settings.calendar_name }}
        </div>
        <ValidateMessage :error="validateErrors.calendar_id" />
      </div>
    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="tag-form"
          class="btn btn-primary">{{ isSynced ? $t('Update') : $t('Starts sync') }}</button>
      </div>
    </template>

  </modalo>

</template>

<script>
export default {
  name: 'GoogleSyncForm',
  components: {
  },
  props: {
    initSettings: {
      type: Object,
      default: () => { return {} }
    }
  },
  data () {
    return {
      creating: true,
      loading: true,
      calendars: [],
      settings: this.$clone(this.initSettings || {}),
      validateErrors: {}
    }
  },
  created () {
    this.loadCalendars()
  },
  computed: {
    isSynced () {
      return this.settings ? this.settings.synced : false
    }
  },
  methods: {
    loadCalendars () {
      this.loading = true
      this.axios.get('/accounts/' + this.$store.getters.getAccount._id + '/profile/calendar-provider/calendars').then(response => {
        this.calendars = response.data
        this.creating = this.loading = false
      })
    },
    /*
    hideModal
    */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    startSync
    */
    startSync (data) {
      this.loading = true

      if (!this.isSynced) {
        this.axios.put('/accounts/' + this.$store.getters.getAccount._id + '/profile/calendar-provider/start-sync', data).then(response => {
          this.$emit('updated')
        }).catch((err) => {
          this.loading = false
          if (err.response.data.name === 'ValidationError') {
            this.validateErrors = err.response.data.errors
          }
        })
      } else {
        this.axios.put('/accounts/' + this.$store.getters.getAccount._id + '/profile/calendar-provider/settings', data).then(response => {
          this.$emit('updated')
        }).catch((err) => {
          this.loading = false
          if (err.response.data.name === 'ValidationError') {
            this.validateErrors = err.response.data.errors
          }
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/ProfileCalendarSettings/GoogleSyncForm.vue